export default {
    defaultButtons: {
        cancel: 'cancel',
        save: 'save',
        delete: 'delete',
        download: 'download',
        ok: 'ok',
        submit: 'submit',
        update: 'update',
        uploadImage: 'Upload Image',
        confirm: 'Confirm',
        changePayment: 'change payment',
        start: 'Start',
        run: 'Run',
        pause: 'Pause',
        finish: 'Finish',
        resume: 'Resume'
    }
};
